namespace $ {
	/** @deprecated Use $mol_crypto2_nonce */
	export let $mol_crypto_salt = $mol_crypto2_nonce
}
